module.exports = __webpack_public_path__ + "img/software-thumb-3.a33eb34f.webp";